import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import Busines from './views/business/busines.vue'
import Brief from './views/brief/brief.vue'
import Casecenter from './views/casecenter/casecenter.vue'
import Newscenter from './views/newscenter/newscenter.vue'
import Talent from './views/talent/talent.vue'
import Concat from './views/concat/concat.vue'
Vue.use(Router)

export default new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition
        }
        return {
            x: 0,
            y:0
        }
    },
    routes: [{
            path: '/',
            name: 'Home',
            component: Home
        },
        {
            path: '/busines',
            name: 'Busines',
            component: Busines
        },
        {
            path: '/brief',
            name: 'Brief',
            component: Brief
        }, {
            path: '/casecenter',
            name: 'Casecenter',
            component: Casecenter
        },
        {
            path: '/newscenter',
            name: 'Newscenter',
            component: Newscenter
        },
        {
            path: '/talent',
            name: 'Talent',
            component: Talent
        },
        {
            path: '/concat',
            name: 'Concat',
            component: Concat
        }
    ]
})